<app-activatiegetal [range]="data"></app-activatiegetal>
